import { Card, Skeleton } from "antd";
import styled from "styled-components";

const CardShimmerStyle = styled.div`
.ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding : 0px;
}
.ant-skeleton-element .ant-skeleton-button {
    min-width:0px;
    width:100%;
    border-radius : 3px;
    }
    .ant-skeleton-element .ant-skeleton-input {
        min-width:0px;
        width:100%;
        border-radius : 3px;
        }
        .ant-skeleton-element {
            width:100%;
        }
`;
const SmallShimmer = styled.div`

.ant-skeleton-element .ant-skeleton-button {
    min-width:0px;
    width: 20%;
    }
`;
const LargeShimmer = styled.div`

.ant-skeleton-element .ant-skeleton-button {
min-width:0px;
width: 80%;
}
`;

export default function PaperMachineCardShimmer() {
  return (
    <CardShimmerStyle>
      <Card
        // hoverable
        bodyStyle={{ height: "150px" ,borderRadius:'8px'}}
      >
                    {/* <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'20%',flexDirection:'column',margin:'5px 5px 10px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'20px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'80%',flexDirection:'column',margin:'5px 5px 10px 5px'}}>
                    <Skeleton.Input  active={true}  style={{height:'20px'}}></Skeleton.Input>
                    </div>
                    </div>

                    </div>
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'70%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'30%',flexDirection:'column'}}>
                    </div>
                    </div>

                    </div>
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'80%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'20%',flexDirection:'column'}}>
                    </div>
                    </div>

                    </div>
                    <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'80%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'20%',flexDirection:'column'}}>
                    </div>
                    </div>

                    </div> */}
                    <div style={{width:'100%',display:'flex',height:'100%'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <div style={{width:'20%',flexDirection:'column',margin:'0px 5px 0px 5px',display:'flex',justifyContent:'center'}}>
                    <Skeleton.Button  active={true}  style={{height:'40px'}}></Skeleton.Button>
                    </div>
                    <div style={{width:'80%',flexDirection:'column',margin:'0px 5px 0px 5px',marginTop:'15px',marginLeft:'20px'}}>
                    <div style={{flexDirection:'row',display:'flex',width:'100%',marginTop:'10px'}}>
                    <Skeleton.Button  active={true}  style={{height:'20px'}}></Skeleton.Button>
                    </div>
                    <div style={{flexDirection:'row',display:'flex',width:'70%',marginTop:'10px'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{flexDirection:'row',display:'flex',width:'70%'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    <div style={{flexDirection:'row',display:'flex',width:'40%'}}>
                    <Skeleton.Button  active={true}  style={{height:'10px'}}></Skeleton.Button>
                    </div>
                    </div>
                    {/* <div style={{width:'50%',flexDirection:'column',margin:'0px 5px 0px 5px'}}>
                    <Skeleton.Button  active={true}  style={{height:'30px'}}></Skeleton.Button>
                    </div> */}
                    </div>

                    </div>

      
      </Card>
      </CardShimmerStyle>
  );
}